import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Box, Card, Link, Tab, TabPanel, Tabs, Typography, ViewContainer } from 'components/AORedesign';
import ClaimsReport from './ClaimsReport';
import ClaimsSearch from './ClaimsSearch';
import ClaimsStatus from './ClaimsStatus';

import { ROUTE_REDESIGN_REPORTS_AGENT_PLRREPORTS } from 'constants/routes';
import AppDataContext from '../../contexts/appData.context';
import { handleTabChange } from '../CommonUtilityServices/EventHandlerService';

const Claims = () => {
  const { claimsInquiry, setClaimsInquiry } = useContext(AppDataContext);

  const [tabValue, setTabValue] = useState(0);

  const history = useHistory();

  useEffect(() => {
    if (claimsInquiry) {
      setTabValue(2);
    }
  }, [claimsInquiry]);

  useEffect(() => {
    const url = window.location.href;
    const anchor = 'open-claims-status';
    if (url.includes(anchor)) {
      setTabValue(1); // Change the tab value to open claims status from dashboard
    }
  }, []);

  const handleGoToRoute = (e) => {
    const route = e.currentTarget.getAttribute('data-route');
    history.push(route);
  };

  return (
    <ViewContainer title="Claims">
      <Card>
        <Tabs
          aria-label="tabs-claims"
          variant="scrollable"
          scrollButtons="auto"
          value={tabValue}
          onChange={(e, newValue) => handleTabChange(e, newValue, setTabValue)}>
          <Tab id="claims-search" label="Report a Claim" aria-controls="at-tabpanel-0" />
          <Tab id="claims-reports" label="Open Claims Status" aria-controls="at-tabpanel-1" />
          <Tab id="claims-forms" label="Claims Inquiry Search" aria-controls="at-tabpanel-2" />
        </Tabs>

        <Box position="relative" mb={3}>
          <Box position="absolute" right={24} top={24}>
            <Link id="claims-loss-report-button" color="secondary" data-route={ROUTE_REDESIGN_REPORTS_AGENT_PLRREPORTS} onClick={handleGoToRoute}>
              Run a Loss Report
            </Link>
          </Box>
        </Box>

        <TabPanel index={0} value={tabValue}>
          <ClaimsReport />
        </TabPanel>
        <TabPanel index={1} value={tabValue}>
          <ClaimsStatus />
        </TabPanel>
        <TabPanel index={2} value={tabValue}>
          <ClaimsSearch claimsInquiry={claimsInquiry} setClaimsInquiry={setClaimsInquiry} />
        </TabPanel>

        <Card variant="outlined" square style={{ marginTop: 16 }}>
          <Typography variant="h6" style={{ marginBottom: 16 }}>
            Quick Links
          </Typography>
          <Link href="https://brandfolder.com/s/sw4n66rf9mjjjfth84km6k" color="secondary" endIcon="pdf">
            WoW! Claim Service
          </Link>
        </Card>
      </Card>
    </ViewContainer>
  );
};

export default Claims;
